import type { intlFormatPropTypes } from "react-intl";

import useHostHubUpcomingBookings from "../../hooks/useHostHubUpcomingBookings";
import HostHubUpcomingPanelBookings from "./HostHubUpcomingPanelBookings";
import HostHubUpcomingPanelEmptyState from "./HostHubUpcomingPanelEmptyState";
import HostHubUpcomingPanelHeader from "./HostHubUpcomingPanelHeader";

type HostHubUpcomingPanelProps = {
  intl: intlFormatPropTypes;
};

const HostHubUpcomingPanel = ({ intl }: HostHubUpcomingPanelProps) => {
  const { bookings, isError, isLoading } = useHostHubUpcomingBookings();

  if (isLoading || isError) return null;

  const hasUpcomingBookings = bookings.length > 0;
  const panelBody = hasUpcomingBookings ? (
    <HostHubUpcomingPanelBookings intl={intl} />
  ) : (
    <HostHubUpcomingPanelEmptyState />
  );

  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-gap-[16px] tw-rounded-8 tw-bg-brand-white tw-p-[24px] tw-shadow-xl">
      <HostHubUpcomingPanelHeader />
      {panelBody}
    </div>
  );
};

export { HostHubUpcomingPanel };
